import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function DogIcon(props) {
  return(
      <img src="/Icons/dog.svg" alt="dog" {...props}/>
  )
}